var blockSliders = [];

ready(function(){

	// -- type home slider --
	const homeSlider = document.querySelectorAll('.glide.type--homeSlider');
	if (homeSlider.length) {
		const autoplaySpeed = getComputedStyle(document.querySelector(':root')).getPropertyValue('--homeSliderDur');
		const homeSliderOptions = {
			type: 'carousel',
			autoplay: autoplaySpeed,
			animationDuration: 0,
			animationTimingFunc: false,
			swipeThreshold: false,
			dragThreshold: false,
			hoverpause: false,
		};
		const homeSlider = new Glide('.glide.type--homeSlider', homeSliderOptions);
		homeSlider.on(['mount.after', 'run'], () => {
			const currentIndex = homeSlider.index;
			const allBullets = document.querySelectorAll('.glide.type--homeSlider .glide__bullet .border');
			const activeBullet = document.querySelectorAll(`.glide.type--homeSlider .glide__bullet[data-glide-dir="=${currentIndex}"] .border`);
			for (let i = 0; i < allBullets.length; i++) {
				allBullets[i].classList.remove('animate-drawcircle');
			}
			activeBullet[0].classList.add('animate-drawcircle');
		});				
		homeSlider.mount();
	}



	// -- type block slider --
	const blockSlider = document.querySelectorAll('.glide.type--blockSlider');
	if (blockSlider.length) {
		const blockSliderOptions = {
			type: 'slider',
			perView: 2.3,
			// perView: 1.7,
			gap: 10,
			bound: true,
			animationDuration: 800,
			breakpoints: {
				767: {
					perView: 1,
					gap: 0,
				}
			}
		};
		blockSlider.forEach(glide => {
			var slider = new Glide(glide, blockSliderOptions);
			var currentPage = glide.closest('.blockSlider').querySelector('.glide__pagination .current');
			var arrows = glide.closest('.blockSlider').querySelectorAll('.glide__arrow');
			// -- update current pagination --
			slider.on(['mount.after', 'run'], () => {
				const currentIndex = slider.index + 1;
				currentPage.innerText = currentIndex.toString().padStart(2, '0');
			});
			// -- arrows navigation --
			arrows.forEach(arrow => {
				arrow.addEventListener('click', function(){
				  slider.go(this.getAttribute('data-glide-dir'));
				});
			});
			slider.mount();
			blockSliders.push(slider);
		});
	}
});